import { NewCategory } from '../../types';
import api from '../../utils/api';

export const createCategory = (variables: NewCategory) =>
  api.post({
    url: `/category`,
    variables,
  });
